<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>person</md-icon>
        </div>
        <h4 class="title">User Info</h4>
      </md-card-header>
      <md-card-content class="md-layout">
        <div class="md-layout-item md-size-25 md-small-size-50">
          <md-field>
            <label>First Name</label>
            <md-input v-model="user.first_name" :disabled="true" />
          </md-field>
        </div>
        <div class="md-layout-item md-size-25 md-small-size-50">
          <md-field>
            <label>Last Name</label>
            <md-input v-model="user.last_name" :disabled="true" />
          </md-field>
        </div>
        <div class="md-layout-item md-size-25 md-small-size-50">
          <md-field>
            <label>Username</label>
            <md-input v-model="user.username" :disabled="true" />
          </md-field>
        </div>
        <div class="md-layout-item md-size-25 md-small-size-50">
          <md-field>
            <label>Email</label>
            <md-input v-model="user.email" :disabled="true" />
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <label>Rewards Program Orders</label>
            <md-input v-model="user.order_count" :disabled="true" />
          </md-field>
          <md-field>
            <label>Phone</label>
            <md-input :value="formatNumber(user.phone_number)" :disabled="true" />
            <md-button v-if="user.phone_number" class="md-icon-button md-danger" @click="removePhoneNumber">
              <md-icon>close</md-icon>
            </md-button>
            <md-button v-else class="md-icon-button md-success" @click="addPhoneNumber">
              <md-icon>add</md-icon>
            </md-button>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <label>Balance</label>
            <md-input :value="formatBalance(wallet.balance)" :disabled="true" />
          </md-field>
          <md-field>
            <label>Free Fees Left</label>
            <md-input v-model="wallet.free_fee_count" :disabled="true" />
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <label># Merchants</label>
            <md-input v-model="user.merchant_count" :disabled="true" />
          </md-field>
          <md-field>
            <label>First Order</label>
            <md-input :value="formatDate(user.first_ordered)" :disabled="true" />
          </md-field>
          <md-field>
            <label>Last Order</label>
            <md-input :value="formatDate(user.last_ordered)" :disabled="true" />
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <label>Total Spent</label>
            <md-input :value="formatDouble(user.spent)" :disabled="true" />
          </md-field>
          <md-field>
            <label>Total Save</label>
            <md-input :value="formatDouble(user.saved)" :disabled="true" />
          </md-field>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import IntToMoneyFormatter from "@/mixins/money-formatter-mixin.js"
import PhoneFormatter from "@/mixins/phone-formatter-mixin.js"
import moment from "moment"

export default {
  name: "user-info-card",
  mixins: [ IntToMoneyFormatter, PhoneFormatter ],
  props: {
    user: {
      type: Object,
      default: null
    },
    wallet: {
      type: Object,
      default: null
    }
  },
  methods: {
    addPhoneNumber() {
      this.$emit("addPhoneNumber")
    },
    removePhoneNumber() {
      this.$emit("removePhoneNumber")
    },
    formatDouble(value) {
      if (value) {
        var parsedValue = parseFloat(value)
        return this.formatter.format(parsedValue)
      }
      else {
        return "-"
      }
    },
    formatDate(value) {
      return value ? moment(value).format('MM/DD/YY') : 'N/A'
    },
  }
}
</script>

<style lang=scss>
.hide-overflow-x {
  overflow-x: hidden;
}
</style>